import React, { useEffect } from 'react';
import { Route } from "react-router-dom";

const RouteWithTitle = ({ component: Component, render, title, ...rest }) => {
  useEffect(() => {
    if (!title) return;
    const fullTitle = "ReVUe - " + title;
    document.title = fullTitle;
    return () => document.title = "ReVUe";
  }, [title]);

  const renderFunction = props => <Component {...props} />
  return (
    <Route {...rest} render={render || renderFunction} />
  )
};

export default RouteWithTitle;